// @ts-nocheck
import React, { useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import CustomSelectField from "../../../commonComponents/CommonSelect";
import CustomTextField from "../../../commonComponents/TextFieldComponent";
import { handleFetchApi, ApiRequestParams } from "../../../../utils/api";
import { getInvestorApiUrl } from "../../../../utils/config";
import CommonHeading from "../../../../components/commonComponents/commonHeading";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import Loading from "../../../../components/Loading";
import { UseSelector } from "react-redux";
import ButtonComponents from "../../../../components/commonComponents/ButtonComponents";
import { useNavigate } from "react-router-dom";
import {Typography} from "@mui/material";
import {Link} from "@mui/material";
const documentTypes = [
  { value: "id_passport", label: "Passport" },
  { value: "id_passport_card", label: "Passport Card" },
  { value: "doc_green_card", label: "Green Card" },
  { value: "id_drivers_license", label: "Driver's License" },
  { value: "id_drivers_permit", label: "Driver's Permit" },
  { value: "id_state", label: "State ID" },
];
const stateDocumentTypes = ["id_drivers_license", "id_drivers_permit", "id_state"];
const countryDocumentTypes = ["id_passport", "id_passport_card", "doc_green_card"];
const countryOptions = [{ value: "US", label: "US" }]; 
const Document = () => {
  const navigate= useNavigate()
  const { loginInvestorId } =  useSelector((state: RootState) => state.user);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { states } = useSelector((state) => state.stateCounty);
  const rawParams = useParams();

  const [formData, setFormData] = useState({
    documentType: "",
    documentId: "",
    documentState: "",
    documentCountry: "",
  });

  const [errors, setErrors] = useState({});
  const validateField = (name, value, currentFormData) => {
    let errorMsg = "";
    if (name === "documentType" && !value) {
      errorMsg = "Please select a document type";
    }
    if (name === "documentId" && !value) {
      errorMsg = "Please enter document ID";
    }
    if (
      name === "documentState" && 
      stateDocumentTypes.includes(currentFormData.documentType) &&
      !value
    ) {
      errorMsg = "Please select document state";
    }
    if (
      name === "documentCountry" &&
      countryDocumentTypes.includes(currentFormData.documentType) &&
      !value
    ) {
      errorMsg = "Please select document country";
    }
    return errorMsg;
  };

const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => {
    const updatedForm = { ...prev, [name]: value };

    if (name === "documentType") {
      if (!stateDocumentTypes.includes(value)) {
        updatedForm.documentState = "";
      }
      if (!countryDocumentTypes.includes(value)) {
        updatedForm.documentCountry = "";
      }
    }

    const newError = validateField(name, value, updatedForm);
    const newErrors = { ...errors, [name]: newError };
    if (
      name !== "documentType" && // skip when documentType changes
      (name === "documentState" || name === "documentType") && // just for safety, you can also remove the 'name === "documentType"' here
      stateDocumentTypes.includes(updatedForm.documentType)
    ) {
      newErrors.documentState = validateField(
        "documentState",
        updatedForm.documentState,
        updatedForm
      );
    } else if (name !== "documentState") {
      newErrors.documentState = "";
    }
    if (
      name !== "documentType" && // skip when documentType changes
      (name === "documentCountry" || name === "documentType") &&
      countryDocumentTypes.includes(updatedForm.documentType)
    ) {
      newErrors.documentCountry = validateField(
        "documentCountry",
        updatedForm.documentCountry,
        updatedForm
      );
    } else if (name !== "documentCountry") {
      newErrors.documentCountry = "";
    }

    setErrors(newErrors);
    return updatedForm;
  });
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.documentType) newErrors.documentType = "Please select a document type";
    if (!formData.documentId) newErrors.documentId = "Please enter document ID";
    if (stateDocumentTypes.includes(formData.documentType) && !formData.documentState) {
      newErrors.documentState = "Please select document state";
    }
    if (countryDocumentTypes.includes(formData.documentType) && !formData.documentCountry) {
      newErrors.documentCountry = "Please select document country";
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      const payloadWithInvestor = {
        ...formData,
        investorId:loginInvestorId,
      };

      const params: ApiRequestParams = {
        method: "POST",
        baseUrl: getInvestorApiUrl(),
        endpoint: "registration/add-id-document",
        payload: payloadWithInvestor,
      };

      try {
        console.log("API Request Params:", params);
        setLoading(true);
        setSuccessMessage("");
        setErrorMessage("");
        const res = await handleFetchApi(params);
        if (res?.data?.statusCode == 200) {
          setSuccessMessage("Document details submitted successfully")
          setFormData({
            documentType: "",
            documentId: "",
            documentState: "",
            documentCountry: "",
          })
        } else {
          toast.error("We were unable to submit your information. Please try again later or contact support if the issue persists.", {
            className: 'custom-toast'
          });
        }
        console.log("response is", res)
      } catch (err) {
        toast.error("We were unable to submit your information. Please try again later or contact support if the issue persists.", {
          className: 'custom-toast'
        });
        console.error("API error:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  const isSubmitDisabled = () => {
    const hasErrors = Object.values(errors).some((error) => error && error.length > 0);

    const requiredEmpty =
    
      !formData.documentType ||
      !formData.documentId ||
      (stateDocumentTypes.includes(formData.documentType) && !formData.documentState) ||
      (countryDocumentTypes.includes(formData.documentType) && !formData.documentCountry);

    return hasErrors || requiredEmpty;
  };

  return (
    <Box p={3}>
      <CommonHeading
        sx={{ mb: 2, fontWeight: "600", fontSize: 22, mt: { sm: "20px", md: "0px", xs: "2px" } }}
        heading={"Please provide document information to complete the verification process"}
      />
      <Grid sx={{ pr: { xs: 0, sm: 5, md: 15 }, mt: 3, background: "white", padding: 2, borderRadius: "8px" }}>

        {loading ? (<Loading height="200px" />) : successMessage ? (<div style={{
          height: "200px",
          display: "block",
          paddingTop: "39px",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}>
          <Typography   
           variant="h5"
        component="h5"
        sx={{
          fontWeight: 500,
          fontSize: { xs: "1.25rem", md: "20px" },
          color: "text.primary",
          mb: 2,
        }}>{successMessage}</Typography>
              <Typography variant="body2" sx={{ color: "#666" }}>
                  Explore
            <Link
              href="/search"
              underline="none"
              sx={{
                color: "#FF5C39",
                fontWeight: "600",
                mx: 1,
                textDecoration: "Underline",
              }}
            >
              foreclosure properties
            </Link>
            </Typography>
             
        </div>) : (<form onSubmit={handleSubmit} className="h-[200px]">
          <div className="grid md:grid-cols-2 mb-3 gap-3 md:gap-4 mt-4 ">
            <CustomSelectField
              label="Govt / State issued ID"
              name="documentType"
              options={documentTypes}
              value={formData.documentType}
              onChange={handleChange}
              error={!!errors.documentType}
              helperText={errors.documentType}
              data-testid="document-type-field"
            />

            <CustomTextField
              label="Document ID"
              name="documentId"
              value={formData.documentId}
              onChange={handleChange}
              error={!!errors.documentId}
              helperText={errors.documentId}
              data-testid="document-id-field"
            />

            {stateDocumentTypes.includes(formData.documentType) && (
              <CustomSelectField
                label="Document State"
                name="documentState"
                sx={{ mt: 1 }}
                options={states}
                value={formData.documentState}
                onChange={handleChange}
                error={!!errors.documentState}
                helperText={errors.documentState}
                data-testid="document-state-field"
              />
            )}

            {countryDocumentTypes.includes(formData.documentType) && (
              <CustomSelectField
                label="Document Country"
                name="documentCountry"
                sx={{ mt: 1 }}
                options={countryOptions}
                value={formData.documentCountry}
                onChange={handleChange}
                error={!!errors.documentCountry}
                helperText={errors.documentCountry}
                data-testid="document-country-field"
              />
            )}
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              disabled={isSubmitDisabled()&&loginInvestorId}
              className={`px-4 py-2 rounded text-white mt-7 ${isSubmitDisabled()
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-orange-600 hover:bg-orange-600"
                }`}
            >
              Submit
            </button>
          </div>
        </form>)}
      </Grid>
    </Box>
  );
};

export default Document;
